(function() {
  function fixProductImages() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.product-item--vertical .product-item__image-wrapper').forEach(function(wrapper) {
      var ar = wrapper.querySelector('.aspect-ratio');
      if (ar) {
        ar.style.cssText += '; padding-bottom: 0 !important; height: 130px !important;';
      }
      var img = wrapper.querySelector('img');
      if (img) {
        img.style.cssText += '; position: relative !important; top: auto !important; left: auto !important; transform: none !important; width: 100% !important; height: 130px !important; object-fit: contain !important;';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fixProductImages);
  window.addEventListener('load', fixProductImages);
  setTimeout(fixProductImages, 500);
  setTimeout(fixProductImages, 2000);
})();
